/**
 * Transform frontend customization format to API format.
 *
 * Frontend stores customizations as:
 *   Record<groupId, selection> where selection can be:
 *     - number[]           (array of option IDs)
 *     - Record<optionId, quantity>  (object with quantities)
 *     - number             (scalar option ID)
 *
 * API expects: Array<{ group_id: number; option_id: number }>
 */
export function transformCustomizationsToApi(
  customizations: Record<number, number | number[] | Record<number, number>> | undefined
): { group_id: number; option_id: number }[] {
  const result: { group_id: number; option_id: number }[] = []

  if (customizations === undefined) return result

  Object.entries(customizations).forEach(([groupId, selection]) => {
    if (Array.isArray(selection)) {
      selection.forEach((optionId) => {
        result.push({ group_id: parseInt(groupId), option_id: optionId })
      })
      return
    }

    if (typeof selection === 'object') {
      Object.entries(selection).forEach(([optionId, quantity]) => {
        const normalizedQuantity = Number.isFinite(quantity) ? Math.max(0, quantity) : 0

        Array.from({ length: normalizedQuantity }).forEach(() => {
          result.push({ group_id: parseInt(groupId), option_id: parseInt(optionId) })
        })
      })
      return
    }

    if (typeof selection === 'number' && selection !== 0 && !Number.isNaN(selection)) {
      result.push({ group_id: parseInt(groupId), option_id: selection })
    }
  })

  return result
}
